/**
 * @description Gestion de la liste des démarches
 */

/* global Drupal, jQuery, drupalSettings */

(function ($, Drupal, drupalSettings) {
	Drupal.behaviors.submitStyle = {
		attach: function (context, drupalSettings) {
			const root = document.querySelector('.view-demarches-solr');

			// si le span contenant les informations dépasse de la div, aligner le span avec son item à droite
			const infosPosition = () => {
				const item = root.querySelectorAll('.demarches__item');
				item.forEach((el) => {
					const maxWidth = el.getBoundingClientRect().right;
					const infos =
						el.querySelectorAll('.demarches__content') || null;
					if (infos) {
						infos.forEach((info) => {
							const infoRight =
								info.getBoundingClientRect().right;

							if (infoRight > maxWidth) {
								const div =
									info.parentNode.getBoundingClientRect()
										.right;
								const positionRight = div - maxWidth;
								info.style.right = positionRight + 'px';
							}
						});
					}
				});
			};

			// Function to show tooltip before footer of other elements out of main
			const zIndexMain = () => {
				document.querySelector('main').style.zIndex = 1;
			};

			const init = () => {
				if (root) {
					infosPosition();
					zIndexMain();
				}
			};

			init();
		},
	};
})(jQuery, Drupal, drupalSettings);
